import { useEffect } from 'react';
import { StatNumber } from '../components/StatNumber.jsx';
import { portfolioContent } from '../content/portfolioContent.js';

// The experience detail as its own hash-addressable view (#/experience) —
// the flat page's role card readable as a page, so the journey-mode tile
// (which only fits the stat strip) can link out the same way the case tiles
// do: teaser tile → "Read the detail →" → this view.
export function ExperienceOverlay({ onBack, onContact }) {
  const exp = portfolioContent.experience;

  useEffect(() => {
    const heading = document.querySelector('.doc-title');
    if (heading) {
      heading.setAttribute('tabindex', '-1');
      heading.focus({ preventScroll: true });
    }
  }, []);

  return (
    <div className="doc-view experience-detail" id="view-experience">
      <div className="doc-container">
        <a
          href="#experience"
          className="back-link"
          onClick={(event) => {
            event.preventDefault();
            onBack();
          }}
        >
          ← Back to experience
        </a>
        <span className="eyebrow">Experience · Detail</span>
        <h1 className="doc-title">{exp.roleTitle}</h1>
        {/* the scope line gets its own register — same words, lifted out of the
            muted byline where a scanning recruiter would never read it */}
        <p className="role-reframe">{exp.roleReframe}</p>
        <p className="byline">
          {exp.roleMeta[0]} · {exp.roleMeta[1]}
        </p>
        <p className="role-lead">{exp.lead}</p>
        <div className="stat-strip">
          {exp.stats.map((stat) => (
            <div key={stat.label} className="strip-stat">
              <StatNumber target={stat.target} suffix={stat.suffix} />
              <span className="stat-label">{stat.label}</span>
            </div>
          ))}
        </div>
        <ul className="role-duties">
          {exp.duties.map((duty) => (
            <li key={duty.strong}>
              <strong>{duty.strong}</strong>
              {duty.text}
            </li>
          ))}
        </ul>
        <div className="doc-footer">
          <a
            href="#experience"
            onClick={(event) => {
              event.preventDefault();
              onBack();
            }}
          >
            ← Back to experience
          </a>
          <a
            href="#contact"
            onClick={(event) => {
              event.preventDefault();
              onContact();
            }}
          >
            Get in touch →
          </a>
        </div>
      </div>
    </div>
  );
}
